module.exports = __webpack_public_path__ + "img/manager3.8fe888fc.jpg";